export const getVerifiedSlug = /* GraphQL */ `query VerifySlug($input: inputVerifySlug!) {
	verifySlug(input: $input){
		unique
		slug
		input
	}
}
`
